import React, { useState, useEffect, useRef } from "react";

const EventTypeDropdown = ({
	eventTypes,
	onSelect,
	placeholder = "Search event type...",
}) => {
	const [query, setQuery] = useState("");
	const [filtered, setFiltered] = useState(eventTypes);
	const [open, setOpen] = useState(false);
	const containerRef = useRef(null);

	useEffect(() => {
		const handleClickOutside = (e) => {
			if (containerRef.current && !containerRef.current.contains(e.target)) {
				setOpen(false);
			}
		};
		document.addEventListener("mousedown", handleClickOutside);
		return () => document.removeEventListener("mousedown", handleClickOutside);
	}, []);

	useEffect(() => {
		if (!query.trim()) {
			setFiltered(eventTypes);
			return;
		}
		try {
			const regex = new RegExp(query, "i");
			setFiltered(eventTypes.filter((event) => regex.test(event.label)));
		} catch {
			const q = query.toLowerCase();
			setFiltered(
				eventTypes.filter((event) => event.label.toLowerCase().includes(q))
			);
		}
	}, [query, eventTypes]);

	const handleSelect = (event) => {
		onSelect(event);
		setQuery(event.label);
		setOpen(false);
	};

	return (
		<div ref={containerRef} className="relative w-full">
			<input
				type="text"
				placeholder={placeholder}
				value={query}
				onChange={(e) => {
					setQuery(e.target.value);
					setOpen(true);
				}}
				onFocus={() => setOpen(true)}
				className="w-full border border-[#DDDDDD] rounded-md px-2 py-2 outline-none"
			/>

			{open && (
				<div className="absolute top-12 w-full left-0 z-[99999]">
					<div className="bg-white border border-[#DDDDDD] rounded-md w-full cursor-pointer px-1 shadow-sm">
						{filtered.length > 0 ? (
							<ul className="w-full m-auto overflow-auto custom-scrollbar max-h-[250px]">
								{filtered.map((event) => (
									<li
										key={event.value}
										onClick={() => handleSelect(event)}
										className="p-2 cursor-pointer hover:bg-[#fff5f5] hover:rounded-md mt-1"
									>
										{event.label}
									</li>
								))}
							</ul>
						) : (
							<div className="p-2 text-gray-400 text-sm">No results found</div>
						)}
					</div>
				</div>
			)}
		</div>
	);
};

export default EventTypeDropdown;
